import { render, staticRenderFns } from "./insPatientSelectionModal.vue?vue&type=template&id=62c6c740&"
import script from "./insPatientSelectionModal.vue?vue&type=script&lang=js&"
export * from "./insPatientSelectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports